export default "__VITE_ASSET__34fef416__"